/**
 * mock 세션 쿠키 이름. 브라우저(db.ts)와 dev 서버(vite.config.ts 의 로그아웃·Google 로그인)가 같이 쓴다.
 *
 * 실제 백엔드처럼 세션을 쿠키로 둔다. 로그아웃과 Google 로그인은 페이지 이동이라 MSW 가
 * 가로채지 못하므로, dev 서버가 이 쿠키를 지우거나 심고 `/` 로 돌려보낸다.
 */
export const MOCK_SESSION_COOKIE = "mock_session";

/** mock 사이트가 내려 주는 Google 로그인 주소. → data/site.ts */
export const MOCK_GOOGLE_LOGIN_PATH = "/accounts/google/login/";

/** mock 에서 Google 로그인을 누르면 이 계정으로 들어온다(data/staff.ts 의 id). */
export const MOCK_GOOGLE_USER_ID = "변경민";
